import React from 'react';

export default function repeatComponent(times: number, Component: React.ReactElement) {
	return Array.from({ length: times }).map((_, i) => React.cloneElement(Component, { key: i }));
}